import { SegmentContext } from 'context/SegmentContext';
import { useContext } from 'react';

const useSegment = () => {
  const context = useContext(SegmentContext);
  if (!context) {
    throw new Error('useSegment must be used within a SegmentProvider');
  }
  return context;
};

export default useSegment;
